/* ************************* */
//
// Dreamcoat Signup
// This file will be made available as /assets/dreamcoat/signup.js by webpack
//
/* ************************* */

const {
    getParamsFromQuery,
    escapeHtmlEntities,
} = require("@sugarfrontend/modules/shared");
const { asyncFormSubmit } = require("@sugarfrontend/forms");
const { getParams } = require("@sugarfrontend/modules/ui_utils");
const {
    initLocalForage,
    togglePasswordVisibility,
    updateButtonState,
    isValidEmail,
    showAlertBox,
    hideAlertBox,
    recaptchaV3Ping,
} = require("./utils");

/** reCAPTCHA v2 automatic render: data-callback on `.g-recaptcha` */
window.signupRecaptchaV2Callback = function () {
    if (typeof validateForm === "function") {
        validateForm();
    }
};

// DOM Elements
let signupForm = null,
    signupButtonEl = null,
    signupLabelEl = null,
    emailDisplayEl = null,
    emailDisplayWrapperEl = null,
    emailInputEl = null,
    emailInputWrapperEl = null,
    firstNameEl = null,
    lastNameEl = null,
    passwordEl = null,
    togglePasswordBtn = null;

/** Set in document.ready when ?recaptcha=v2 or options.recaptcha === "v2" */
let useRecaptchaV2Mode = false;

// reCAPTCHA v3 site key from options
const RECAPTCHA_SITE_KEY = window.options?.recaptchaSiteKey || "";
const RECAPTCHA_SITE_KEY_V2 = window.options?.recaptchaSiteKeyV2 || "";

const SIGNUP_V2_DRAFT_KEY = "sw_dc_signup_v2_draft";

function saveSignupDraftForV2Reload() {
    if (!signupForm || !signupForm.length) return;
    const gender = $("input[name='gender']:checked", signupForm).val() || "";
    try {
        sessionStorage.setItem(
            SIGNUP_V2_DRAFT_KEY,
            JSON.stringify({
                firstName: firstNameEl.val() || "",
                lastName: lastNameEl.val() || "",
                gender,
                email: emailInputEl.val() || "",
                emailDisplayText: emailDisplayEl.text() || "",
            })
        );
    } catch (e) {
        /* ignore quota / private mode */
    }
}

/** @returns {boolean} true if a draft was restored */
function restoreSignupDraftAfterV2Reload() {
    let raw;
    try {
        raw = sessionStorage.getItem(SIGNUP_V2_DRAFT_KEY);
    } catch (e) {
        return false;
    }
    if (!raw) return false;
    let d;
    try {
        d = JSON.parse(raw);
    } catch (e) {
        sessionStorage.removeItem(SIGNUP_V2_DRAFT_KEY);
        return false;
    }
    sessionStorage.removeItem(SIGNUP_V2_DRAFT_KEY);
    if (!firstNameEl || !lastNameEl || !passwordEl || !signupForm) return false;
    if (d.firstName) firstNameEl.val(d.firstName);
    if (d.lastName) lastNameEl.val(d.lastName);
    if (d.gender) {
        $("input[name='gender']", signupForm).prop("checked", false);
        $("input[name='gender']", signupForm).each(function () {
            if (this.value === d.gender) {
                $(this).prop("checked", true);
            }
        });
    }
    if (emailInputWrapperEl.is(":visible") && d.email) {
        emailInputEl.val(d.email);
    } else if (d.emailDisplayText && emailDisplayWrapperEl.is(":visible")) {
        emailDisplayEl.text(d.emailDisplayText);
        emailInputEl.val(d.email || d.emailDisplayText);
    }
    passwordEl.val("");
    return true;
}

$(document).ready(function () {
    const params = getParamsFromQuery(document.location.search);
    useRecaptchaV2Mode =
        params.recaptcha === "v2" ||
        (window.options && window.options.recaptcha === "v2");

    // Clear localforage
    initLocalForage();
    if (!useRecaptchaV2Mode) {
        recaptchaV3Ping("signup_view");
    }

    // Initialize DOM elements
    signupForm = $("#dc-signup-form");
    signupButtonEl = $("#signup-button", signupForm);
    signupLabelEl = $("#signup-label-span", signupForm);
    emailDisplayEl = $("#display-email", signupForm);
    emailDisplayWrapperEl = $("#email-display-wrapper", signupForm);
    emailInputEl = $("#email", signupForm);
    emailInputWrapperEl = $("#email-input-wrapper", signupForm);
    firstNameEl = $("#firstName", signupForm);
    lastNameEl = $("#lastName", signupForm);
    passwordEl = $("#password", signupForm);
    togglePasswordBtn = $("#toggle-password", signupForm);

    if (params.email) {
        const email = decodeURIComponent(params.email);
        emailDisplayEl.text(email);
        emailInputEl.val(email);
    }
    if (params.unverified) {
        $(".title").text("Let’s create your account");
    }
    // Handle showEmailInput parameter (default is false - email not editable)
    if (params.showEmailInput === "true") {
        // Show email input (editable)
        emailInputWrapperEl.show();
        emailDisplayWrapperEl.hide();
    } else {
        // Hide email input, show display only (default behavior)
        emailInputWrapperEl.hide();
        emailDisplayWrapperEl.show();
    }

    if (useRecaptchaV2Mode && restoreSignupDraftAfterV2Reload()) {
        // showAlertBox(
        //     "alert-container",
        //     "info",
        //     "For your security, please re-enter your password before continuing."
        // );
    }

    // Event Listeners
    firstNameEl.on("input", validateForm);
    lastNameEl.on("input", validateForm);
    passwordEl.on("input", validateForm);
    $("input[name='gender']", signupForm).on("change", validateForm);

    // Password visibility toggle
    togglePasswordBtn.on("click", function () {
        togglePasswordVisibility(passwordEl, togglePasswordBtn);
    });

    // Form submission - attach handler early to prevent default form submit
    signupForm.on("submit", function (e) {
        e.preventDefault();
        sanitizeInputs();
        hideMessage();
        updateButtonView("working");

        if (useRecaptchaV2Mode && RECAPTCHA_SITE_KEY_V2) {
            if (typeof grecaptcha === "undefined") {
                updateButtonView("ready");
                showMessage(
                    "reCAPTCHA is still loading. Please wait a moment and try again."
                );
                return;
            }
            const token = grecaptcha.getResponse();
            if (!token) {
                updateButtonView("ready");
                showMessage("Please complete the reCAPTCHA verification.");
                return;
            }
            asyncFormSubmit(signupForm, signupFormSuccess, signupFormError);
            return;
        } else if (typeof grecaptcha !== "undefined" && RECAPTCHA_SITE_KEY) {
            // Execute reCAPTCHA v3 and get token before submitting
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(RECAPTCHA_SITE_KEY, { action: "signup" })
                    .then(function (token) {
                        $("#g-recaptcha-response").val(token);
                        asyncFormSubmit(
                            signupForm,
                            signupFormSuccess,
                            signupFormError
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);
                        updateButtonView("ready");
                        showMessage(
                            "reCAPTCHA verification failed. Please try again."
                        );
                    });
            });
        } else {
            // Fallback if reCAPTCHA is not loaded
            asyncFormSubmit(signupForm, signupFormSuccess, signupFormError);
        }
    });

    // Set OTP expire time
    $("#otpExpireTime").val(moment().add(1, "hour").format("h:mm A"));

    // Initial validation
    validateForm();
});

// Sanitize inputs to prevent XSS
function sanitizeInputs() {
    firstNameEl.val(escapeHtmlEntities(firstNameEl.val()));
    lastNameEl.val(escapeHtmlEntities(lastNameEl.val()));
    emailInputEl.val(escapeHtmlEntities(emailInputEl.val()));
}

// Form validation
function validateForm() {
    const isValid = isFormValid();
    signupButtonEl.prop("disabled", !isValid);
}

function isFormValid() {
    // Check required fields
    if (!firstNameEl.val().trim()) return false;
    if (!lastNameEl.val().trim()) return false;
    if (!passwordEl.val() || passwordEl.val().length < 8) return false;
    if (!$("input[name='gender']:checked", signupForm).length) return false;
    // Validate email if input is visible
    if (
        emailInputWrapperEl.is(":visible") &&
        !isValidEmail(emailInputEl.val().trim())
    )
        return false;

    if (useRecaptchaV2Mode && RECAPTCHA_SITE_KEY_V2) {
        if (typeof grecaptcha === "undefined") return false;
        if (!grecaptcha.getResponse()) return false;
    }

    return true;
}

// Form success handler
function signupFormSuccess(result) {
    const { userId, email } = result;
    updateButtonView("success");
    const paramValue = getParams("url");
    const url = paramValue ? paramValue : window.location.pathname;
    window.location.href = `/verify-otp/${userId}?smallOtp=true&email=${encodeURIComponent(
        email
    )}&url=${url}`;
}

// Form error handler
function signupFormError(error) {
    updateButtonView("ready");

    if (error && error.recaptchaVerified === false) {
        const params = getParamsFromQuery(window.location.search);
        const alreadyV2 =
            params.recaptcha === "v2" ||
            (window.options && window.options.recaptcha === "v2");
        if (!alreadyV2) {
            saveSignupDraftForV2Reload();
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.set("recaptcha", "v2");
            window.location.assign(nextUrl.toString());
            return;
        }
    }

    if (
        typeof grecaptcha !== "undefined" &&
        useRecaptchaV2Mode &&
        typeof grecaptcha.reset === "function"
    ) {
        grecaptcha.reset();
    }

    showMessage((error && error.message) || "Something went wrong.");
    // reCAPTCHA v3 doesn't need reset - a new token is obtained on each submit
}

// Button view updates
function updateButtonView(state) {
    updateButtonState(signupButtonEl, signupLabelEl, state, validateForm);
}

// Message display (box error at top)
function showMessage(msg) {
    hideMessage();
    showAlertBox("alert-container", "error", msg);
}

function hideMessage() {
    hideAlertBox();
}
